export enum PVP_GAME_STRATEGY {
	BUY = 'buy',
	SELL = 'sell',
	HOLD = 'hold',
}

export enum PVP_GAME_STATUS {
	PENDING = 'pending',
	WON = 'won',
  LOST = 'lost',
  DRAW = 'draw',
}
